export default {
  methods: {
    setBodyClass (className) {
      this.clearBodyClass()
      document.body.classList.add(className)
    },
    clearBodyClass () {
      this.clearBodyAttribute('class')
      // document.body.removeAttribute('class')
    },
    clearBodyAttribute (attribute) {
      document.body.removeAttribute(attribute)
    },
    // TODO: must remove after add vue-meta
    setPageTitle (title) {
      document.title = title
    },
    addBodyClass (className) {
      document.body.classList.add(className)
    },
    addDataAttribute (name, value) {
      var attribute = document.createAttribute(name)
      attribute.value = value
      document.body.attributes.setNamedItem(attribute)
    },
    getMobileOperatingSystem () {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera
      if (/windows phone/i.test(userAgent)) {
        return 'Windows Phone'
      }
      if (/android/i.test(userAgent)) {
        return 'Android'
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS'
      }
      return 'unknown'
    }
  }
}
